import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Sidebar from "../../components/sidebar";
import RespondAlert from "../../components/field_alerts/RespondAlert";
import { Container, SideContainer } from "../main_display/styles";

const ScrollSide = styled(SideContainer)`
  overflow-x: hidden !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
`;

export default function RespondAlertPage() {
  const collapsed = useSelector((state) => state.sidebar);
  const [localCollapsed, setLocalCollapsed] = useState(false);

  return (
    <Container>
      <Sidebar
        collapsed={localCollapsed.toString()}
        setCollapsed={setLocalCollapsed}
      />
      <ScrollSide collapsed={(collapsed || localCollapsed).toString()}>
        <RespondAlert />
      </ScrollSide>
    </Container>
  );
}
